import React from 'react';
import * as Tools from '../../../../helpers/Tools';
import { CircleButton, Tooltip } from '../../index';

export const CircleButtonTooltip = ({
    as,
    icon,
    onClick,
    tooltip,
}) => {

    const label = tooltip ? tooltip.text : '';
    const tooltipId = tooltip ? tooltip.id : '';
    const isMobileDevice = Tools.isMobile();

    const button = <CircleButton
        aria-describedby={tooltipId && !isMobileDevice ? tooltipId : ""}
        aria-label={tooltipId && !isMobileDevice ? "" : label}
        colorStyle='float'
        icon={icon?.name ? icon?.name : 'x'}
        size={icon?.size ? icon?.size : 'small' }
        onClick={onClick}
        as={as}
    />;

    return (tooltipId && !isMobileDevice
        ? <Tooltip
            text={label}
            tooltipId={tooltipId ? tooltipId : ""}
        >
            {button}
        </Tooltip>
        : button
    );
};